document.addEventListener('alpine:init', () => {
  Alpine.data('ProductForm', () => ({
    formEl: null,
    submitting: false,
    init() {
      this.formEl = this.$root.querySelector('form');
      if (this.formEl) {
        this.formEl.addEventListener('submit', this.submit.bind(this));
      }
    },
    async submit(event) {
      event.preventDefault();
      // Lock this form while the request is in flight, including quick-buy forms.
      if (this.submitting) return;
      this.submitting = true;
      let formData;
      let formId;
      const reportError = (message, errors = message) => {
        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:error', {
            detail: {
              sourceId: formId,
              variantId: formData ? formData.get('id') : null,
              errors,
              message,
            },
            bubbles: true,
          })
        );
      };
      try {
        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:loading', { bubbles: true })
        );
        liveRegion(window.theme.strings.loading);
        const form = event.currentTarget || event.target;
        formData = new FormData(form);
        formId = form.getAttribute('id');
        const options = fetchConfigDefaults('application/javascript');
        formData.set('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
        formData.set('sections_url', window.location.pathname);
        options.body = formData;
        options.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete options.headers['Content-Type'];
        const response = await fetch(theme.routes.cart_add_url, options);
        const data = await response.json();
        if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid cart response');
        if (!response.ok || data.status) {
          const message = data.description || data.message || theme.strings.cartError || 'Your cart could not be updated. Please check your cart before trying again.';
          reportError(message, data.errors || data.description || message);
          return;
        }
        // Release the UI before either rendering the drawer or taking the full-cart fallback.
        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:success', { bubbles: true })
        );
        // The cart can update successfully even when bundled sections fail.
        // Read the full cart instead of retrying the add and risking duplicates.
        const requiredSections = ['cart-items', 'cart-footer', 'cart-item-count'];
        if (!data.sections || requiredSections.some((key) => typeof data.sections[key] !== 'string' || !data.sections[key].trim())) {
          const root = window.Shopify?.routes?.root || '/';
          window.location.assign(theme.routes.cart_url || `${root}cart`);
          return;
        }
        document.body.dispatchEvent(
          new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true,
            detail: { response: data },
          })
        );
      } catch (error) {
        // A lost response does not prove that Shopify rejected the cart update.
        reportError('We could not confirm the update to your cart. Check your cart before trying again.');
        console.error('Hunted+Gathered cart request failed', error);
      } finally {
        this.submitting = false;
      }
    },
  }));
});
